export const onChangeHandler = send => (_event, value) => {
  send({
    type: 'CHANGE',
    value: value
  });
};
export const onChangeValueHandler = send => value => {
  send({
    type: 'CHANGE',
    value: value
  });
};
export const onBlurHandler = send => () => {
  send([{
    type: 'BLUR'
  }, {
    type: 'COMMIT'
  }]);
};
export const onFocusHandler = send => () => {
  send({
    type: 'FOCUS'
  });
};
export const commitChanges = (send, isInit, setIsInit) => () => {
  if (isInit) {
    // We want to avoid commiting changes when `value` is set after
    // the parent `InputGroupMachine` is initiliased it's `data` object.
    setIsInit(false);
  } else {
    send([{
      type: 'BLUR'
    }, {
      type: 'COMMIT'
    }, {
      type: 'FOCUS'
    }]);
  }
};